import { createRouter } from "router5";
import browserPlugin from "router5-plugin-browser";
import listenersPlugin from "router5-plugin-listeners";
import loggerPlugin from "router5-plugin-logger";
export function newRouter({ withBrowser, withLogger, routes, defaultRoute, }) {
    const router = createRouter(routes, {
        defaultRoute,
        allowNotFound: true,
        // Stringify true values without value.
        queryParams: {
            booleanFormat: "empty-true",
        },
        // Automatically cleanup canDeactivate funcs/bools when the node
        // deactivates
        autoCleanUp: true,
    });
    // required by react-router5
    router.usePlugin(listenersPlugin());
    if (withLogger) {
        router.usePlugin(loggerPlugin);
    }
    if (withBrowser) {
        router.usePlugin(browserPlugin());
    }
    return router;
}
